import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import SearchIcon from 'mdi-react/SearchIcon';
import CloseIcon from 'mdi-react/CloseIcon';

export const SearchWrapper = styled.div`
  position: relative;
`;

export const SearchInput = styled.input`
  font-size: ${layout.measurements.fontSizeNormal};
  width: 100%;
  padding: ${layout.measurements.spacing050} ${layout.measurements.spacing100};
  outline: 0;
  border-radius: 4px;
  border: 1px solid ${p => p.theme.lines.tertiary};

  &:focus {
    border-color: ${p => p.theme.lines.highlight};
  }
`;

export const ClearSearchButton = styled.button`
  align-items: center;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  display: flex;
  height: 100%;
  padding: ${layout.measurements.spacing050};
  position: absolute;
  right: 0;
  top: 0;
`;

export const EmptySearchIcon = styled(SearchIcon).attrs(p => ({
  color: p.theme.icons.tertiary,
}))``;

export const ClearSearchIcon = styled(CloseIcon).attrs(p => ({
  color: p.theme.icons.tertiary,
}))``;
